import { LAYOUTS } from "./general";

export const getTranscriptBody = (text, from, to) => {
  return {
    text: text,
    from_lang: from,
    to_lang: to,
  };
};

export const getCreateAvatarVideoBody = (
  userId,
  projectId,
  slideId,
  text,
  voiceId,
  presenterId
) => {
  return {
    text,
    voiceId,
    presenterId,
    projectId,
    slideId,
    userId,
  };
};

export const getVoiceGenerateBody = (
  userId,
  projectId,
  slideId,
  text,
  voiceCode,
  pitch = 0,
  speakingRate = 0
) => {
  return {
    userId,
    projectId,
    slideId: slideId,
    text: text,
    voiceCode: voiceCode,
    pitch: pitch,
    speakingRate: speakingRate,
  };
};

export const saveProjectBody = ({
  templateId,
  name,
  jsonData = null,
  slideSnapshots = [],
  category = "",
  layout = LAYOUTS.LANDSCAPE,
  layoutDimension = "w=1920xh=1080",
  firstImage = null,
  coverInformation = null,
  bgMusic = null,
  user,
  isFaceless,
  isDoc,
  isLinkVideo,
  // isNonVoice,
}) => {
  return {
    bg_music: bgMusic,
    cover_information: coverInformation,
    first_image: firstImage,
    category: category,
    json_data: jsonData,
    slide_snapshots: slideSnapshots,
    layout: layout,
    name: name,
    template_id: templateId,
    layoutDimension: layoutDimension,
    user,
    isFaceless,
    isDoc,
    isLinkVideo,
    // isNonVoice,
  };
};

export const generateVideoBody = (obj, project) => {
  const { scaleFactor, bgMusic, isFaceless, isNonVoice } = project;
  const { layout, dimension } = obj;

  const test = obj.slides.map((item, index) => {
    const modifyObj = {};
    item.objects.forEach((obj) => {
      // if (!modifyObj[obj.type]) modifyObj[obj.type] = [];
      modifyObj[obj.type === "backgroundImage" ? "background" : obj.type] = {
        ...obj,
      };
    });

    const avatar = modifyObj.avatar;
    const background = modifyObj.background;
    const backgroundVideo = modifyObj.backgroundVideos
      ? { ...modifyObj.backgroundVideos }
      : null;
    delete modifyObj.backgroundVideos;
    delete modifyObj.backgroundColor;
    let voiceObj = {
      noaudio: true,
      duration: "7",
    };
    return {
      transData: {
        usedText: item.is_user_audio
          ? undefined
          : isNonVoice
          ? ""
          : item.script || "hello test",
        text: item.is_user_audio
          ? undefined
          : isNonVoice
          ? ""
          : item.script || "hello test",
        avatarGender: avatar?.gender || "male",
        voice: isNonVoice ? voiceObj : item.voiceFile,
        languageValue: "en-US",
        voiceValue: item.voice,
        transcriptLang: "",
        srt: "",
        url: "",
        transText: "",
        accentOption: false,
        captionOption: false,
        is_user_audio: !!item.is_user_audio,
      },
      maxAnimDuration: 1,
      duration: 5,
      slideData: null,
      ...modifyObj,
      backgroundVideo: backgroundVideo
        ? {
            top: 0,
            left: 0,
            url: backgroundVideo.url,
            opacity: 100,
            width: 1920,
            height: 1080,
          }
        : undefined,
      background:
        !backgroundVideo && background
          ? {
              top: 0,
              left: 0,
              url: background.url,
              opacity: 100,
              width: background.width,
              height: background.height,
            }
          : null,
      avatar: avatar
        ? {
            square: avatar.square,
            user_avatar: avatar.user_avatar,
            angle: avatar.angle,
            url: avatar.url,
            visible: avatar.visible,
            avatarCode: avatar.avatarCode,
            opacity: avatar.opacity,
            width: avatar.width,
            height: avatar.height,
            scaleX: avatar.scaleX * scaleFactor,
            scaleY: avatar.scaleY * scaleFactor,
            top: avatar.top * scaleFactor,
            left: avatar.left * scaleFactor,
            pro_avatar: avatar.pro_avatar ? true : undefined,
          }
        : undefined,
      subtitle: item.subtitle || undefined,
    };
  });

  return {
    dimension,
    layout: layout,
    bgmusic: bgMusic || null,
    cover: {
      is_cover: false,
    },
    free: false,
    userId: obj.userId,
    projectId: obj.projectId || "wqwupxmd64",
    slides: [...test],
    dimension: dimension || LAYOUTS.LANDSCAPE,
  };

  // return {
  //   userId: 637,
  //   projectId: "wqwupxmd64",
  //   slides: [
  //     {
  //       transData: {
  //         avatarGender: "male",
  //         usedText: "Test",
  //         text: "Test",
  //         voice: {
  //           wav: "/media/user_data/637/wqwupxmd64/wqwupxmd64_0.wav",
  //           mp3: "/media/user_data/637/wqwupxmd64/wqwupxmd64_0.mp3",
  //         },
  //         languageValue: "en-US",
  //         voiceValue: "en-US-GuyNeural",
  //         transcriptLang: "",
  //         srt: "",
  //         url: "",
  //         transText: "",
  //         accentOption: false,
  //         captionOption: false,
  //       },
  //       duration: 5,
  //       background: null,
  //       avatar: {
  //         square: false,
  //         top: 10,
  //         left: 20,
  //         user_avatar: false,
  //         angle: 0,
  //         url: "https://www.vidboard.ai/media/avatars/avt1.png",
  //         visible: true,
  //         avatarCode: "avt1",
  //         opaciity: 100,
  //         width: 500,
  //         height: 500,
  //         scaleX: 0.6400000000000001,
  //         scaleY: 0.6400000000000001,
  //       },
  //       maxAnimDuration: 1,
  //       slideData: null,
  //     },
  //   ],
  //   layout: "w=1920xh=1080",
  //   bgmusic: null,
  //   cover: {
  //     is_cover: false,
  //   },
  //   free: false,
  // };
};
export const generateSlideFramesBody = (
  userId,
  projectId,
  captureSlide,
  slide,
  index,
  height,
  width,
  scaleFactor
) => {
  console.log("slide Frame Non voice", slide);
  const modifyObj = {};
  slide.objects.forEach((obj) => {
    modifyObj[obj.type] = { ...obj };
  });
  const isNonVoice = slide?.isNonVoice;
  const avatar = modifyObj.avatar;
  const background = modifyObj.background;
  const backgroundVideo = modifyObj.backgroundVideos;
  const bgColor = modifyObj?.backgroundColor?.color;
  const voiceObj = {
    noaudio: true,
    duration: "7",
  };
  return {
    userId: userId,
    projectId: projectId,
    noOfSlides: index + 1,
    slideId: index,
    free: false,
    slide: {
      layout: `w=${width}xh=${height}`,
      backgroundVideo: backgroundVideo
        ? {
            top: 0,
            left: 0,
            url: backgroundVideo.url,
            opacity: 100,
            width: 1920,
            height: 1080,
          }
        : undefined,
      backgroundColor: background?.url
        ? undefined
        : !backgroundVideo && bgColor
        ? bgColor
        : undefined,

      background:
        !backgroundVideo && background
          ? {
              top: 0,
              left: 0,
              url: background.url,
              opacity: 100,
              width: background.width,
              height: background.height,
            }
          : null,
      avatar: avatar
        ? {
            square: avatar.square,
            user_avatar: avatar.user_avatar,
            angle: avatar.angle,
            url: avatar.url,
            visible: avatar.visible,
            avatarCode: avatar.avatarCode,
            opacity: avatar.opacity,
            width: avatar.width,
            height: avatar.height,
            scaleX: avatar.scaleX * scaleFactor,
            scaleY: avatar.scaleY * scaleFactor,
            top: avatar.top * scaleFactor,
            left: avatar.left * scaleFactor,
            pro_avatar: avatar.pro_avatar,
          }
        : null,
      duration: 5,
      transData: {
        usedText: slide.is_user_audio
          ? undefined
          : isNonVoice
          ? ""
          : slide.script || "hello test",
        text: slide.is_user_audio
          ? undefined
          : isNonVoice
          ? ""
          : slide.script || "hello test",
        avatarGender: "male",
        voice: isNonVoice ? voiceObj : slide.voiceFile,
        languageValue: "en-US",
        voiceValue: slide.voice,
        transcriptLang: "",
        srt: "",
        url: "",
        transText: "",
        accentOption: false,
        captionOption: false,
        is_user_audio: !!slide.is_user_audio,
      },
      slideData: captureSlide || [],
      start: 0,
    },
  };

  // return {
  //   userId: userId,
  //   projectId: projectId,
  //   noOfSlides: index,
  //   slideId: index,
  //   free: false,
  //   slide: {
  //     layout: "w=1920xh=1080",
  //     avatar: {
  //       square: false,
  //       top: 10,
  //       left: 20,
  //       user_avatar: false,
  //       angle: 0,
  //       url: "https://www.vidboard.ai/media/avatars/avt1.png",
  //       visible: true,
  //       avatarCode: "avt1",
  //       opaciity: 100,
  //       width: 500,
  //       height: 500,
  //       scaleX: 0.6400000000000001,
  //       scaleY: 0.6400000000000001,
  //     },
  //     background: null,
  //     duration: 5,
  //     transData: {
  //       avatarGender: "male",
  //       usedText: "Test",
  //       text: "Test",
  //       voice: {
  //         wav: "/media/user_data/637/wqwupxmd64/wqwupxmd64_0.wav",
  //         mp3: "/media/user_data/637/wqwupxmd64/wqwupxmd64_0.mp3",
  //       },
  //       languageValue: "en-US",
  //       voiceValue: "en-US-GuyNeural",
  //       transcriptLang: "",
  //       srt: "",
  //       url: "",
  //       transText: "",
  //       accentOption: false,
  //       captionOption: false,
  //     },
  //     slideData: [captureSlide],
  //     start: 0,
  //   },
  // };
};
